import React from 'react';
import { ModernButton } from '../ui/ModernButton';
import { SaveIcon } from '../ui/Icons';

export function EditorActions({
  position = 'bottom',
  showQuestionButtons = true,
  onAddQuestion,
  templateName,
  onTemplateNameChange,
  onSaveAsTemplate,
  onGenerateLink,
  onExport,
  allowMultipleSubmissions = false,
  onAllowMultipleSubmissionsChange
}) {
  return (
    <div className={`${position === 'bottom' ? 'mt-6 sm:mt-8 pt-6 border-t' : 'mb-6 sm:mb-8 pb-4 border-b'} border-slate-200`}>
      <div className="flex flex-wrap gap-4 items-stretch justify-start">
        <div className="flex flex-wrap gap-2 w-full sm:w-auto">
          {showQuestionButtons && (
            <>
              <ModernButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); onAddQuestion('text'); }} variant="secondary" size="md">+ Textfrage</ModernButton>
              <ModernButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); onAddQuestion('single-choice'); }} variant="secondary" size="md">+ Single-Choice</ModernButton>
              <ModernButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); onAddQuestion('multiple-choice'); }} variant="secondary" size="md">+ Multiple-Choice</ModernButton>
              <ModernButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); onAddQuestion('ranking'); }} variant="secondary" size="md">+ Ranking</ModernButton>
              <ModernButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); onAddQuestion('matrix'); }} variant="secondary" size="md">+ Matrix</ModernButton>
              <ModernButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); onAddQuestion('combobox'); }} variant="secondary" size="md">+ Combobox</ModernButton>
              <ModernButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); onAddQuestion('image'); }} variant="secondary" size="md">+ Bild</ModernButton>
              <ModernButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); onAddQuestion('file-upload'); }} variant="secondary" size="md">+ Datei-Upload</ModernButton>
            </>
          )}
          {position === 'bottom' && (
            <>
              <button
                type="button"
                onClick={() => onAllowMultipleSubmissionsChange && onAllowMultipleSubmissionsChange(!allowMultipleSubmissions)}
                aria-pressed={allowMultipleSubmissions}
                className={`w-full flex items-start gap-3 p-4 rounded-xl border text-left transition-all ${
                  allowMultipleSubmissions
                    ? 'border-green-500 bg-green-50 dark:bg-green-900/20 dark:border-green-600'
                    : 'border-slate-200 bg-white hover:border-slate-300 dark:border-slate-700 dark:bg-slate-800/50 dark:hover:border-slate-600'
                }`}
              >
                <span
                  className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-md border-2 transition-colors mt-0.5 ${
                    allowMultipleSubmissions
                      ? 'border-green-600 bg-green-600'
                      : 'border-slate-300 bg-white dark:border-slate-600 dark:bg-slate-800'
                  }`}
                  aria-hidden="true"
                >
                  {allowMultipleSubmissions && (
                    <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                    </svg>
                  )}
                </span>
                <span className="flex-1 min-w-0">
                  <span className="block text-sm font-semibold text-slate-800 dark:text-slate-100">
                    Mehrfachdurchführung erlauben
                  </span>
                  <span className="block text-xs text-slate-500 dark:text-slate-400 mt-0.5">
                    Mehrere Bewerber können denselben Fragebogen-Link nutzen. Dieselbe Person darf trotzdem nur einmal einreichen.
                  </span>
                </span>
              </button>
              <div className="flex w-full sm:w-auto min-w-0 max-w-xs">
                <input
                  type="text"
                  value={templateName}
                  onChange={(e) => onTemplateNameChange(e.target.value)}
                  placeholder="Vorlagenname"
                  className="flex-1 sm:flex-none p-3 border border-slate-300 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 rounded-l-lg min-w-0 focus:outline-none focus:ring-0 focus:border-green-600"
                />
                <button
                  onClick={onSaveAsTemplate}
                  className="px-3 py-3 bg-slate-600 text-white rounded-r-lg hover:bg-slate-700 flex items-center justify-center whitespace-nowrap"
                  aria-label="Vorlage speichern"
                  title="Vorlage speichern"
                >
                  <SaveIcon />
                </button>
              </div>
              {onExport && (
                <ModernButton
                  onClick={onExport}
                  variant="secondary"
                  size="lg"
                  icon={<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1m-4-8l-4-4m0 0L8 8m4-4v12" /></svg>}
                >
                  Exportieren
                </ModernButton>
              )}
              <ModernButton
                onClick={onGenerateLink}
                variant="success"
                size="lg"
                icon={<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" /></svg>}
              >
                Fragebogen erstellen
              </ModernButton>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
